export const getYear = (date: string) => {
  if (!date) {
    return new Date().getFullYear();
  }

  return date.split("-")[0];
};

export const getMonth = (date: string) => {
  if (!date) {
    return new Date().getMonth() + 1;
  }

  return date.split("-")[1].replace("0", "");
};
